import { Component } from '@angular/core';
import { Router } from '@angular/router';

export type MiscReportSection = 'incident' | 'more';

@Component({
  selector: 'app-misc-report',
  templateUrl: './misc-report.component.html',
  styleUrls: ['./misc-report.component.css']
})
export class MiscReportComponent {

  activeSection: MiscReportSection = 'incident';

  constructor(public router: Router) { }

  get isSettingsMiscRoute(): boolean {
    return this.router.url.indexOf('/settings/misc-report') >= 0;
  }

  selectSection(section: MiscReportSection): void {
    this.activeSection = section;
  }
}
